/** Per-route lock applies only before T+3 handoff (when autoDispatchToggleAllowed is true). */
export const isAutoDispatchRouteLockActive = (toggleAllowed: boolean | undefined): boolean => toggleAllowed ?? true;
